// Reuse the existing one-use browser ticket and server validation. No ERP token
// enters SaaS storage; ordinary web login keeps its existing behavior.
let pending = null
let generation = 0
let activeStore
export const registerWorkstationStore = store => { activeStore = store }
export const cancelWorkstationSession = () => { generation++; pending = null }
export const hasWorkstationSession = () => typeof window.__JZ_WORKSTATION_SAAS_RENEW__ === 'function'
function requestContext() {
  let user = activeStore?.user
  if (!user) {
    try { user = JSON.parse(atob(localStorage.getItem('token').split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))) } catch {}
  }
  return { generation, user: String(user?.id || user?.userId || user?._id || ''),
    tenant: String(user?.tenantId || user?.tenant_id || user?.tenant?.id || '') }
}
const sameContext = before => {
  const after = requestContext()
  return before && before.user && before.generation === after.generation && before.user === after.user && before.tenant === after.tenant
}
export function captureWorkstationRequest(config) {
  if (hasWorkstationSession()) config.__workstationContext = requestContext()
  return config
}
async function request(url, options) {
  const controller = new AbortController()
  const timer = setTimeout(() => controller.abort(), 10000)
  try { return await fetch(url, { ...options, signal: controller.signal }) }
  finally { clearTimeout(timer) }
}
export function recoverWorkstationSession(store) {
  if (!hasWorkstationSession()) return Promise.resolve(false)
  if (pending) return pending
  const previous = localStorage.getItem('token')
  let claims = {}
  try { claims = JSON.parse(atob(previous.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))) } catch {}
  const identity = store.user || claims
  const userId = value => String(value?.id || value?.userId || value?._id || '')
  const tenantId = value => String(value?.tenantId || value?.tenant_id || value?.tenant?.id || '')
  const epoch = generation
  const current = () => generation === epoch && localStorage.getItem('token') === previous
  pending = (async () => {
    const ticket = await window.__JZ_WORKSTATION_SAAS_RENEW__()
    if (!current()) throw new Error('登录状态已变化')
    const exchange = await request('/api/auth/workstation-sso/browser-exchange', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ticket })
    })
    const payload = await exchange.json()
    const token = payload?.data?.token
    if (!exchange.ok || !token) throw new Error('工作台身份交换失败')
    const validation = await request('/api/auth/validate', { headers: { Authorization: `Bearer ${token}` } })
    const data = await validation.json()
    if (!validation.ok || !data.user) throw new Error('工作台账号无权访问当前业务')
    if (!current()) throw new Error('登录状态已变化')
    if (previous && (!userId(identity) || userId(identity) !== userId(data.user) || tenantId(identity) !== tenantId(data.user))) {
      throw new Error('业务账号或租户已变化，请关闭并重新打开页面')
    }
    store.setToken(token)
    store.setUser(data.user)
    store.setLoginTime()
    return true
  })().finally(() => { if (generation === epoch) pending = null })
  return pending
}

export async function retryWorkstationAxios(error, client, store = activeStore) {
  const config = error.config
  if (!store || !hasWorkstationSession() || error.response?.status !== 401 || !config || config.__workstationRetried
      || !sameContext(config.__workstationContext)) throw error
  config.__workstationRetried = true
  if (config.headers?.Authorization === `Bearer ${localStorage.getItem('token')}`) await recoverWorkstationSession(store)
  if (!sameContext(config.__workstationContext)) throw error
  if (!['get', 'head'].includes(String(config.method || 'get').toLowerCase())) throw error
  return client(config)
}

export async function workstationFetch(input, options = {}) {
  const context = requestContext()
  const response = await fetch(input, options)
  const url = new URL(input, location.href)
  const headers = new Headers(options.headers)
  if (response.status !== 401 || !activeStore || !hasWorkstationSession()
      || url.origin !== location.origin || !url.pathname.startsWith('/api/') || !headers.has('Authorization') || !sameContext(context)) return response
  if (headers.get('Authorization') === `Bearer ${localStorage.getItem('token')}`) await recoverWorkstationSession(activeStore)
  if (!sameContext(context)) return response
  if (!['GET', 'HEAD'].includes(String(options.method || 'GET').toUpperCase())) return response
  headers.set('Authorization', `Bearer ${localStorage.getItem('token')}`)
  return fetch(input, { ...options, headers })
}
